import Api from './baseApi';
export default {
    searchFormulas: (Order) => {
        let url = "/api/poolFormulas?v=1"
        if (Order.search)
            url += `&q=${Order.search}`;
        if (Order.state > -1)
            url += `&state=${Order.state}`;
        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        return Api.get(url)
    },
    getFormula: (id) => Api.get(`/api/poolFormulas/${id}`),
    putFormula: (Order) => Api.put(`/api/poolFormulas/${Order.id}`, Order),
    deleteFormula: (Order) => Api.delete(`/api/poolFormulas/${Order.id}`, Order),
    postFormula: (Order) => Api.post(`/api/poolFormulas`, Order),
}